import LoyaltyDashboardPage from '@fhs-legacy/frontend/src/pages/loyalty/loyalty-dashboard';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function DetailsPage() {
  return <LoyaltyDashboardPage />;
}
